import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Journey,
  LateRenewalCallCenterConditions,
  LateRenewalConditions,
  PageRelativePath
} from '../../../consts/Common';
import Checkbox from '../../common/Checkbox/Checkbox';
import { SiteContext } from '../../../context/SiteContext';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { useTranslation } from 'react-i18next';

const LateRenewalAcceptance = (): JSX.Element => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { site } = useContext(SiteContext);
  const { t } = useTranslation();

  const lateRenewalConditions =
    site.journeyType === Journey.CallCentre
      ? LateRenewalCallCenterConditions
      : LateRenewalConditions;

  const [conditionStates, setConditionStates] = useState<boolean[]>([]);

  useEffect(() => {
    const initialConditionStates: boolean[] = [];
    lateRenewalConditions.forEach(() => initialConditionStates.push(false));
    setConditionStates(initialConditionStates);

    window.scrollTo(0, 0);
  }, []);

  const onChange = (index: number) => {
    const updatedConditionStates = conditionStates.map((conditionState, i) =>
      i === index ? !conditionState : conditionState
    );

    setConditionStates(updatedConditionStates);
  };

  const onNext = () => {
    if (state) {
      navigate(getNextPage(), { state });
    }
  };

  const getNextPage = () => {
    const result =
      site.journeyType === Journey.CallCentre
        ? PageRelativePath.VehicleDetails
        : PageRelativePath.PersonalDetails;

    return result;
  };

  const disableContinue = conditionStates.some((v) => v === false);

  const callCentreExpiryHeading = t('landing-page.call-centre-expiry-heading');
  const callCentreExpiryMessage = t('landing-page.call-centre-expiry-message');
  const callCentreExpiryInstructions = t(
    'landing-page.call-centre-expiry-instructions'
  );
  const callCentrePriceChangeMessage = t(
    'landing-page.call-centre-price-change-message'
  );

  return (
    <div>
      {site.journeyType !== Journey.CallCentre && (
        <>
          <h3>{callCentreExpiryHeading}</h3>
          <p className='p2'>{callCentreExpiryInstructions}</p>
        </>
      )}

      {site.journeyType === Journey.CallCentre && (
        <p className='p2 m1-top'>{callCentreExpiryMessage}</p>
      )}

      <div className='form form-left-border'>
        {lateRenewalConditions.map((condition, i) => (
          <Checkbox
            key={`condtion-control-${i}`}
            id={`condition-${i}`}
            checked={conditionStates[i] || false}
            text={condition}
            onChange={() => onChange(i)}
          />
        ))}
      </div>
      {site.journeyType !== Journey.CallCentre && (
        <p>{callCentrePriceChangeMessage}</p>
      )}
      <div className='flex-row form-nav mobile-width-90pc'>
        <ButtonContinue
          name='btn-continue'
          text={t('landing-page.button-continue-text')}
          onClick={onNext}
          disabled={disableContinue}
        />
      </div>
    </div>
  );
};

export default LateRenewalAcceptance;
